import type { RssLinkPlatformPreference } from "@app/common/types";
import type {
  CalendarProviderId,
  SSOProviderId,
} from "@app/common/types/providerTypes";

export interface PlatformPreferenceConfig {
  value: RssLinkPlatformPreference;
  label: string;
  comingSoon?: boolean;
  providerId?: Exclude<SSOProviderId, "webex">;
  calendarProviderId?: CalendarProviderId;
}

export const PLATFORM_PREFERENCE_CONFIG: {
  [key in RssLinkPlatformPreference]: PlatformPreferenceConfig;
} = {
  meet: {
    value: "meet",
    label: "Google Meet",
    calendarProviderId: "google_calendar",
  },
  teams: {
    value: "teams",
    label: "Microsoft Teams",
    calendarProviderId: "microsoft_graph_calendar",
  },
  zoom: {
    value: "zoom",
    label: "Zoom",
    calendarProviderId: "zoom_calendar",
  },
  all: {
    value: "all",
    label: "Let recipient choose",
  },
};
